export default __webpack_public_path__ + "2f901655c9994d31bff221111c2aff72.jpg";